import * as types from "../constants/actionTypes";
import initialState from "./initialState";

const quickLinksReducer = (state = initialState.quickLinksData, action) => {
  switch (action.type) {
    case types.FETCH_QUICK_LINKS_STARTED:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case types.FETCH_QUICK_LINKS_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.FETCH_QUICK_LINKS_SUCCEEDED:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null
      };
    default:
      return state;
  }
};

export default quickLinksReducer;
